import { a7 as m, a8 as d } from "./TabGroup-B4jOGf3W.js";
import { useState as f, useCallback as p, useMemo as S } from "react";
import "react/jsx-runtime";
import c from "immutable";
import "fast-levenshtein";
import "fuzzy";
import "fast-deep-equal";
import "./references-BRMYEcTr.js";
function D(o) {
  const t = m(
    () => c.Set(o?.alwaysSelected),
    [o?.alwaysSelected]
  ), l = m(
    () => o?.selectable && c.Set(o.selectable),
    [o?.selectable]
  ), [r, n] = f(t);
  d(() => {
    n((e) => (l ? e.intersect(l) : e).union(t));
  }, [t, l]);
  const a = p(
    (e, b) => {
      n((s) => {
        const i = b ?? !s.has(e);
        return l ? (i ? s.add(e) : s.remove(e)).intersect(l).union(t) : (i ? s.add(e) : s.remove(e)).union(t);
      });
    },
    [t, l]
  ), u = S(
    () => ({
      reset() {
        n(t);
      },
      setSelection(e) {
        n(() => l ? c.Set(e).intersect(l).union(t) : c.Set(e).union(t));
      },
      add(e) {
        a(e, !0);
      },
      remove(e) {
        a(e, !1);
      },
      toggle: a,
      disabled(e) {
        return t.has(e) || l != null && !l.has(e);
      }
    }),
    [t, a, l]
  );
  return S(
    () => ({
      selection: r,
      alwaysSelected: t,
      selectable: l,
      ...u
    }),
    [u, t, r, l]
  );
}
export {
  D as u
};
//# sourceMappingURL=multiselect-U-cZqL-s.js.map
